import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalContatoComponent } from './modal-contato.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IConfig, NgxMaskModule } from 'ngx-mask';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
    declarations: [ModalContatoComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgxMaskModule.forRoot(options)
    ],
    exports: [
        ModalContatoComponent
    ]
})
export class ModalContatoModule { }
